import React from 'react'
import Tiles from 'shared/ui/Tiles'
import Icon from 'shared/ui/Icon'

export default function WorkshopMaterial({ items, iconColor }) {
  return (
    <Tiles minSize={20}>
      {Array.isArray(items) &&
        items.map((item, index) => {
          return (
            <div key={index} className="icon-text">
              <Icon name="check-circle" size={1} color={iconColor} aria-hidden />
              <span className="text-small">{item}</span>
            </div>
          )
        })}
    </Tiles>
  )
}
